module.exports = __webpack_public_path__ + "d6c0fbc4c4910e59570c0b0070e8d76b.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/modelo1.png
// module id = 2812
// module chunks = 1